import { TDraft } from '../models'

export const getInitialSaveAsDraftContact = (): TDraft => ({
  email: '',
  firstName: '',
  lastName: '',
  country: '',
  preferredLanguage: '',
})
